// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"bbfaf33c","100":"47b59ab6","218":"028b9b25","584":"3a3034c9","659":"c9d13f40","787":"b1623a7d","789":"e87c3297","897":"b335b5bb"}[chunkId] + ".chunk.js";
};